@if (loadingItem() === null) {
  <footer class="mt-8">
    <div
      class="mb-8 flex flex-col items-center gap-4 px-3 text-center text-grey-1"
    >
      <a [routerLink]="['/']">
        <img [ngSrc]="logoUrl" alt="Vården.se logotyp" height="24" width="139">
      </a>
      <p>Sveriges största samlingsplats för legitimerad vård och hälsa.</p>
    </div>
    <div
      class="flex flex-col items-center justify-center bg-grey-1 py-8 px-3 text-white hover:text-white"
    >
      <div
        class="flex flex-col justify-between gap-6 md:w-full md:max-w-4xl md:flex-row"
      >
        <div class="flex w-52 flex-col gap-1 text-center">
          <h3 class="uppercase text-lg">Snabblänkar</h3>
          <a
            class="footer-link"
            href="https://vardgivare.varden.se/"
            rel="nofollow"
          >Anslut mottagning</a
          >

          <a
            class="footer-link"
            href="https://chatt.varden.se/"
            rel="nofollow"
          >Chatt <sup class="text-apricot-5 font-black">ny!</sup></a
          >

          <a
            [routerLink]="['/', 'info', 'integritetspolicy']"
            class="footer-link"
            rel="nofollow"
          >Integritetspolicy</a
          >
          <a
            [routerLink]="['/', 'info', 'villkor']"
            class="footer-link"
            rel="nofollow"
          >Allmänna villkor</a
          >
          <a
            (click)="renewConsent($event)"
            class="footer-link"
            href="/"
          >Cookie-preferenser</a
          >
        </div>

        <div class="flex w-52 flex-col gap-1 text-center">
          <h3 class="uppercase text-lg">Socialt</h3>
          <a
            [routerLink]="['/', 'info', 'sociala-medier']"
            class="footer-link"
            rel="nofollow"
          >Våra sociala medier</a
          >
          <a
            class="footer-link"
            href="http://eepurl.com/gKRvPr"
            rel="nofollow"
            target="_blank"
          >Få bättre koll på vården</a
          >
        </div>

        <div class="flex w-52 flex-col gap-1 text-center">
          <h3 class="uppercase text-lg">Om oss</h3>
          <a
            [routerLink]="['/', 'info', 'om-varden', 'om-oss']"
            class="footer-link"
            rel="nofollow"
          >Om Vården.se</a
          >
          <a
            [routerLink]="['/', 'info', 'karriar']"
            class="footer-link"
            rel="nofollow"
          >Karriär</a
          >
          <a
            [routerLink]="['/', 'info', 'om-varden', 'kontakt']"
            class="footer-link"
            rel="nofollow"
          >Kontakta oss</a
          >
        </div>
      </div>
      <p class="mt-6 text-grey-7">
        Copyright © {{ year }} Vården Online Sverige AB
      </p>
    </div>
  </footer>
}

